
import { useState } from 'react';
import Button from '../../../components/base/Button';
import BookingCalendar from '../../../components/feature/BookingCalendar';

export default function ServicesSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const navigateToConsulenza = () => {
    window.REACT_APP_NAVIGATE('/consulenza');
  };

  const navigateToContratto = () => {
    window.REACT_APP_NAVIGATE('/contratto');
  };

  const navigateToFirma = () => {
    window.REACT_APP_NAVIGATE('/firma');
  };

  const navigateToRegistrazione = () => {
    window.REACT_APP_NAVIGATE('/registrazione');
  };

  const navigateToPolizza = () => {
    window.REACT_APP_NAVIGATE('/polizza-morosita');
  };

  const openBookingCalendar = () => {
    setIsBookingOpen(true);
  };

  const scrollToContact = () => {
    const element = document.getElementById('contatti');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      number: '01',
      title: 'Videoconferenza Gratuita Iniziale',
      description: 'Prenota i tuoi 15 minuti gratuiti di videoconferenza. Analizzeremo insieme la tua situazione specifica e ti consiglieremo il contratto di locazione più adatto alle tue esigenze, senza alcun impegno.',
      icon: 'ri-video-chat-fill',
      image: '/images/step1.jpg'
    },
    {
      number: '02',
      title: 'Redazione Contratto in Videoconferenza',
      description: 'Se decidi di proseguire, organizziamo una videoconferenza con il locatore, il conduttore o entrambi. Il nostro agente immobiliare specializzato preparerà il contratto personalizzato in diretta, con la presenza delle parti per garantire massima trasparenza e personalizzazione.',
      icon: 'ri-file-edit-fill',
      image: '/images/step2.jpg'
    },
    {
      number: '03',
      title: 'Pagamento Solo se Soddisfatto',
      description: 'Al termine della redazione, se apprezzi il servizio ricevuto e il contratto preparato, procederai con il pagamento della consulenza. Se non sei completamente soddisfatto, l\'agente non richiederà alcun pagamento e il contratto non verrà inviato. La tua soddisfazione è la nostra priorità.',
      icon: 'ri-shield-check-fill',
      image: '/images/step3.jpg'
    },
    {
      number: '04',
      title: 'Firma e Registrazione (Opzionale)',
      description: 'Una volta completato il contratto, puoi scegliere i servizi aggiuntivi di firma digitale a distanza e registrazione presso l\'Agenzia delle Entrate. Oppure puoi gestire autonomamente questi passaggi con il contratto che hai ricevuto.',
      icon: 'ri-file-shield-2-fill',
      image: '/images/step4.jpg'
    }
  ];

  return (
    <>
      <section id="servizi" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              I Nostri Servizi
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Offriamo soluzioni complete per ogni tipo di contratto di locazione, 
              dalla consulenza alla registrazione ufficiale.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url('/images/service-consulenza.jpg')`
              }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-video-chat-fill text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Consulenza gratuita in Videoconferenza
                </h3>
                <p className="text-gray-600 mb-4">
                  Incontro personalizzato online per analizzare le tue esigenze specifiche 
                  e guidarti nella scelta del contratto più adatto.
                </p>
                <ul className="text-sm text-gray-500 mb-6 space-y-1">
                  <li>• Valutazione esigenze del cliente</li>
                  <li>• Consulenza legale personalizzata</li>
                  <li>• Supporto nella scelta del contratto</li>
                  <li>• Risposta a tutte le tue domande</li>
                </ul>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full cursor-pointer"
                  onClick={navigateToConsulenza}
                >
                  Scopri di Più
                </Button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url('/images/service-contratto.jpg')`
              }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-file-text-fill text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Redazione Contratto Personalizzato
                </h3>
                <p className="text-gray-600 mb-4">
                  Creazione di un contratto di locazione su misura per la tua situazione, 
                  conforme alle normative vigenti e ottimizzato per le tue esigenze.
                </p>
                <ul className="text-sm text-gray-500 mb-6 space-y-1">
                  <li>• Contratto personalizzato</li>
                  <li>• Clausole specifiche per ogni caso</li>
                  <li>• Conformità normative aggiornate</li>
                </ul>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full cursor-pointer"
                  onClick={navigateToContratto}
                >
                  Scopri di Più
                </Button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url('/images/service-firma.jpg')`
              }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-quill-pen-fill text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Firma a Distanza
                </h3>
                <p className="text-gray-600 mb-4">
                  Servizio di firma eletronica qualificata con pieno valore legale.
                </p>
              
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full cursor-pointer"
                  onClick={navigateToFirma}
                >
                  Scopri di Più
                </Button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url('/images/service-registrazione.jpg')`
              }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-shield-check-fill text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Registrazione all'Agenzia delle Entrate
                </h3>
                <p className="text-gray-600 mb-4">
                  Servizio completo di registrazione del contratto presso l'Agenzia delle Entrate, 
                  con gestione di tutta la documentazione e le pratiche burocratiche.
                </p>
                <ul className="text-sm text-gray-500 mb-6 space-y-1">
                  <li>• Registrazione ufficiale AdE</li>
                  <li>• Gestione completa pratiche</li>
                  <li>• Calcolo e pagamento imposte</li>
                  <li>• Certificazione di validità legale</li>
                </ul>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full cursor-pointer"
                  onClick={navigateToRegistrazione}
                >
                  Scopri di Più
                </Button>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  Protezione Totale
                </span>
              </div>
              <div className="h-48 bg-cover bg-center" style={{
                backgroundImage: `url('/images/polizza-card.png')`
              }}></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-shield-star-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Polizza Assicurativa Morosità
                </h3>
                <p className="text-gray-600 mb-4">
                  Tutela completa per il proprietario contro l'inquilino moroso. 
                  Protezione finanziaria e legale per la tua tranquillità.
                </p>
                <ul className="text-sm text-gray-500 mb-6 space-y-1">
                  <li>• Fino a 12 mesi di affitto non pagati</li>
                  <li>• Max 3 mesi per danni e spese condominiali</li>
                  <li>• €2.000 per spese legali di sfratto</li>
                  <li>• Protezione completa del proprietario</li>
                </ul>
                <Button 
                  variant="outline" 
                  size="sm" 
                  className="w-full cursor-pointer"
                  onClick={navigateToPolizza}
                >
                  Scopri di Più
                </Button>
              </div>
            </div>
          </div>

          <div className="mb-16 text-center">
            <div className="bg-blue-50 rounded-xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                <i className="ri-lightbulb-fill text-blue-600 mr-2"></i>
                Perché Scegliere i Nostri Servizi?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-user-star-fill text-2xl text-white"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Esperienza Professionale</h4>
                  <p className="text-gray-600 text-sm">Agente immobiliare qualificato con anni di esperienza nel settore</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-time-fill text-2xl text-white"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Rapidità e Efficienza</h4>
                  <p className="text-gray-600 text-sm">Processo veloce e semplificato, tutto gestito online</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-shield-check-fill text-2xl text-white"></i>
                  </div>
                  <h4 className="font-semibold text-gray-900 mb-2">Sempre Aggiornati</h4>
                  <p className="text-gray-600 text-sm">Contratti su misura conformi alle normative vigenti </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Come Funziona Section */}
      <section id="come-funziona" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Come Funziona
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Un processo semplice, trasparente e senza rischi. Paghi solo se sei completamente soddisfatto del servizio ricevuto.
            </p>
          </div>

          <div className="space-y-16">
            {steps.map((step, index) => (
              <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
                <div className="flex-1">
                  <div className="flex items-center mb-6">
                    <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold mr-4">
                      {step.number}
                    </div>
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <i className={`${step.icon} text-2xl text-blue-600`}></i>
                    </div>
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {step.title}
                  </h3>
                  
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
                
                <div className="flex-1">
                  <div className="rounded-xl overflow-hidden shadow-lg">
                    <img 
                      src={step.image}
                      alt={step.title}
                      className="w-full h-80 object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">
                <i className="ri-shield-star-fill mr-2"></i>
                Garanzia Soddisfatti o Non Paghi
              </h3>
              <p className="text-xl mb-6">
                Prenota subito la tua consulenza gratuita di 15 minuti. Se deciderai di proseguire con la redazione del contratto, pagherai solo se sarai completamente soddisfatto del servizio ricevuto.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button 
                  onClick={openBookingCalendar}
                  className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-video-chat-fill mr-2"></i>
                  Prenota Consulenza Gratuita
                </button>
                <button 
                  onClick={scrollToContact}
                  className="border-2 border-white text-white font-semibold px-8 py-3 rounded-lg hover:bg-white hover:text-blue-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill mr-2"></i>
                  Contattaci
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BookingCalendar 
        isOpen={isBookingOpen} 
        onClose={() => setIsBookingOpen(false)} 
      />
    </>
  );
}
